export { ParagraphSkeleton } from './ParagraphSkeleton';
